import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useGetMeQuery } from "../../../../business.InterfaceLayer/store/entities/auth.entity/redux/api";
import Loader from "../../../Components/UI-KIT/Loader";
import HTTP_STATUSES from "../../../../general/constants/http/httpStatuses";
import { routeBuilder } from "../routeBuilder.service";
import noAuthRoutesPaths from "../../routes/noAuth.route/noAuth.routesPaths";
import {
	useAppDispatch,
	useAppSelector,
} from "../../../../business.InterfaceLayer/store/services/hooks.service/redux.hook";
import {
	authActions,
	authSlice,
} from "../../../../business.InterfaceLayer/store/entities/auth.entity/redux/slice";
import { AUTH_FIELDS } from "../../../../business.InterfaceLayer/store/entities/auth.entity/redux/fields";
import AuthStore from "../../../../old/Store/AuthStore";
import COMMON_FIELDS from "../../../../general/constants/commonFields";
import CabinetRoutesPaths from "../../routes/cabinet.route/cabinet.routesPaths";

const CheckAuth = () => {
	const { isLoading, isSuccess, error, data } = useGetMeQuery({});
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const auth = useAppSelector((state) => state[authSlice.name]);

	useEffect(() => {
		if (!auth[AUTH_FIELDS.TOKEN_ACCESS]) {
			navigate(routeBuilder([noAuthRoutesPaths.AUTHORIZATION]));
		}
	}, [auth, navigate]);

	useEffect(() => {
		if (error?.status === HTTP_STATUSES.UNAUTHORIZED) {
			dispatch(authActions.logout());
			navigate(routeBuilder([noAuthRoutesPaths.AUTHORIZATION]));
		}
	}, [dispatch, error, navigate]);

	useEffect(() => {
		if (isSuccess) {
			const token = auth[AUTH_FIELDS.TOKEN_ACCESS];
			const loginType = "";
			const userId =
				data?.[COMMON_FIELDS.DATA]?.[COMMON_FIELDS.DATA]?.[AUTH_FIELDS.ID];
			const userStatus =
				data?.[COMMON_FIELDS.DATA]?.[COMMON_FIELDS.DATA]?.[AUTH_FIELDS.STATUS];
			const name =
				data?.[COMMON_FIELDS.DATA]?.[COMMON_FIELDS.DATA]?.[
					AUTH_FIELDS.FIRSTNAME
				];
			const surname =
				data?.[COMMON_FIELDS.DATA]?.[COMMON_FIELDS.DATA]?.[AUTH_FIELDS.SURNAME];
			const email =
				data?.[COMMON_FIELDS.DATA]?.[COMMON_FIELDS.DATA]?.[AUTH_FIELDS.EMAIL];

			AuthStore.setBaseInfo(
				token,
				loginType,
				userId,
				userStatus,
				name,
				surname,
				email
			);

			// при авторизации попадать на Программу Лояльности /loyaltyProgram
			// if (!localStorage.getItem("hasRedirected")) {
			// 	navigate(routeBuilder([CabinetRoutesPaths.LOYALTY_PROGRAM]));
			// 	localStorage.setItem("hasRedirected", "true");
			// }
		}
	}, [isSuccess, data, navigate, auth]);

	return isLoading ? (
		<div
			style={{
				minHeight: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Loader />
		</div>
	) : isSuccess ? (
		<Outlet />
	) : null;
};

export default CheckAuth;
